import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }

  /**
   * Encrypts a string using AES encryption algorithm.
   * 
   * @param text - The plain text string to be encrypted
   * @returns The encrypted string in base64 format
   */
  public encrypt = (text: CryptoJS.lib.WordArray | string): string => CryptoJS.AES.encrypt(text, environment.crypto.keyEncrypt).toString();


  /**
   * Decrypts an encrypted string and parses it as JSON
   * @template T - The type to cast the decrypted JSON data to
   * @param {string} ciphertext - The encrypted string to decrypt
   * @returns {T | null} The decrypted data as type T, or null if decryption fails
   */
  public decrypt = <T>(ciphertext: string): T | null => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, environment.crypto.keyEncrypt).toString(CryptoJS.enc.Utf8);
    if (!bytes) {
      return null;
    }
    return JSON.parse(bytes) as T;
  }

  /**
   * Encrypts a string using HmacSHA256 encryption algorithm.
   * You just need to verify that the content has not been modified.
   * @param text - The plain text string to be encrypted
   * @returns The encrypted string in base64 format
   */
  public hmacSha256 = (data: string): string => CryptoJS.HmacSHA256(data, environment.crypto.keyEncrypt).toString();

}
